import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
  PDFViewer,
} from "@react-pdf/renderer";

import headerLogo from "../../asset/johura_logo.png";
import { getuser } from "../../components/CommonDateFormat";
import { useGetProServiceByIdQuery } from "../../features/api/proserviceApi";
import { API_BASE_URL } from "../../components/baseUrl";

const styles = StyleSheet.create({
  page: {
    backgroundColor: "white",
    paddingBottom: "88pt",
  },
  header: {
    color: "white",
    marginBottom: 5,
    textAlign: "center",
    height: "3.8cm",
  },
  imgborder: {
    borderBottom: "1px solid green",
    paddingBottom: "5px",
    marginBottom: "3px",
  },
  HedingTextBorder: {
    borderBottom: "1px solid red",
  },
  footer: {
    color: "white",
    height: "2cm",
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    marginTop: 20,
    textAlign: "center",
    flexDirection: "row",
    justifyContent: "center",
    fontSize: "12",
  },
  footerAddr: {
    color: "black",
    fontSize: "8px",
    margin: "13 auto",
    width: "100%",
    fontWeight: "thin",
  },
  footerBgc: {
    backgroundColor: "#006600",
    height: "0.8cm",
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
  },
  tableRow: {
    borderBottom: 1,
    flexDirection: "row",
  },
  tableCellKey: {
    width: "40%",
    fontSize: 10,
    fontWeight: "bold",
    paddingVertical: "2px",
    paddingHorizontal: "4px",
  },
  tableCellValue: {
    width: "60%",
    fontSize: 10,
    borderLeft: 1,
    paddingVertical: "2px",
    paddingHorizontal: "4px",
  },
  container: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
    marginTop: 32,
  },
  column: {
    alignItems: "center",
    flex: 1,
  },
  signature: {
    width: 48,
    height: 48,
    marginBottom: 4,
    objectFit: "contain",
  },
  signatureText: {
    fontSize: 10,
    fontWeight: "bold",
    borderTop: 1,
    borderColor: "#000",
    paddingTop: 4,
    marginTop: 4,
    textAlign: "center",
  },
});

function DeliveryFormView() {
  const [visible, setVisible] = useState(false);
  const user = getuser();
  const { id } = useParams();

  const { data: productInfo } = useGetProServiceByIdQuery(id, {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true,
  });

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month}, ${year}`;
  };

  return (
    <div className="px-6">
      <div className="flex gap-6 items-center justify-between my-4">
        <div className="flex items-center gap-x-2">
          <input
            onClick={() => setVisible(!visible)}
            type="checkbox"
            className="cursor-pointer"
          />
          <span>Pad logo</span>
        </div>
        <Link
          to="/dashboard/product-services"
          className="border bg-blue-500 px-2 rounded text-white"
        >
          Back
        </Link>
      </div>

      <PDFViewer style={{ width: "100%", height: "100vh" }}>
        <Document>
          <Page size="A4" style={styles.page}>
            {/* Header */}
            <View style={styles.header} fixed>
              {visible && (
                <View>
                  <View style={styles.imgborder}>
                    <Image src={headerLogo} />
                  </View>
                  <Text style={styles.HedingTextBorder}></Text>
                </View>
              )}
            </View>

            <View style={{ marginHorizontal: 20 }}>
              <View style={{ alignItems: "center" }}>
                <Text
                  style={{
                    textAlign: "center",
                    fontSize: 10,
                    padding: 4,
                    backgroundColor: "#C9C9C9",
                    width: "100px",
                  }}
                >
                  DELIVERY FORM
                </Text>
              </View>

              {/* Client Info */}
              <View
                style={{
                  marginVertical: 10,
                  flexDirection: "row",
                  justifyContent: "space-between",
                  width: "100%",
                  fontSize: 12,
                }}
              >
                <View>
                  <View style={{ flexDirection: "row", marginBottom: 2 }}>
                    <Text style={{ width: 80 }}>Client Name</Text>
                    <Text>: {productInfo?.client}</Text>
                  </View>
                  <View style={{ flexDirection: "row", marginBottom: 2 }}>
                    <Text style={{ width: 80 }}>Address</Text>
                    <Text>: {productInfo?.address}</Text>
                  </View>
                  <View style={{ flexDirection: "row" }}>
                    <Text style={{ width: 80 }}>Mobile</Text>
                    <Text>: {productInfo?.mobile}</Text>
                  </View>
                </View>

                <View>
                  <View style={{ flexDirection: "row" }}>
                    <Text style={{ width: 75 }}>Claim Date</Text>
                    <Text>: {formatDate(productInfo?.claim_date)}</Text>
                  </View>
                  <View style={{ flexDirection: "row" }}>
                    <Text style={{ width: 75 }}>Delivery Date</Text>
                    <Text>: {formatDate(productInfo?.delivery_date)}</Text>
                  </View>
                </View>
              </View>

              {/* Table Info */}
              <View style={{ border: 1 }}>
                {[
                  ["Job No.", productInfo?.job_no],
                  ["Brand", productInfo?.brand],
                  ["Product", productInfo?.product],
                  ["Model", productInfo?.model],
                  ["Serial No.", productInfo?.slNo],
                  ["Complain Type", productInfo?.complain_type],
                  ["Warranty", productInfo?.war_type],
                  ["Product Received Date", formatDate(productInfo?.p_r_date)],
                  ["Nature of Complain", productInfo?.nature_claim],
                  ["Accessories", productInfo?.accessories],
                  ["Service Type", productInfo?.service_type],
                  ["Receive Location", productInfo?.p_rcve_loc],
                  ["Previous Job No", productInfo?.prev_jobNo || "N/A"],
                  ["Previous Job Date", formatDate(productInfo?.prev_job_date)],

                  // [
                  //   "Delivery Date (Approx.)",
                  //   formatDate(productInfo?.del_app_date),
                  // ],
                  ["Received By", productInfo?.rcv_by],

                  ["Remarks", productInfo?.remarks],
                  ["Job Done By", productInfo?.job_done_by],
                ].map(([key, value], idx) => (
                  <View style={styles.tableRow} key={idx}>
                    <Text style={styles.tableCellKey}>{key}</Text>
                    <Text style={styles.tableCellValue}>{value}</Text>
                  </View>
                ))}

                <View style={{ ...styles.tableRow, borderBottom: "0px" }}>
                  <Text style={styles.tableCellKey}>Service Details</Text>
                  <View style={styles.tableCellValue}>
                    {productInfo?.service_details
                      ?.split("\n")
                      .map((line, idx) => (
                        <Text key={idx}>{line}</Text>
                      ))}
                  </View>
                </View>
              </View>

              {/* Signature Block */}
              <View style={styles.container}>
                <View style={styles.column}>
                  <Text style={styles.signatureText}>Received by Client</Text>
                </View>
                <View style={styles.column}>
                  <Text style={styles.signatureText}>
                    Prepared By: {productInfo?.created_by}
                  </Text>
                </View>
                <View style={styles.column}>
                  {user?.signature && (
                    <Image
                      src={`${API_BASE_URL}/uploads/${user.signature}`}
                      style={styles.signature}
                    />
                  )}
                  <Text style={styles.signatureText}>
                    For Johura Endomed Solution
                  </Text>
                </View>
              </View>
            </View>

            {/* Footer */}
            <View style={styles.footer} fixed>
              {visible && (
                <>
                  <View style={styles.footerAddr}>
                    <Text>
                      15/A Zigatola, Hafizullah Green Tower, Flat # C1,
                      Dhanmondi, Dhaka - 1209
                    </Text>
                    <Text>
                      Cell: 01711-071102, 01977-071102, 01778-874364, E-mail:
                      jahangirjohura@gmail.com / Web: www.johurabd.com
                    </Text>
                  </View>
                  <Text style={styles.footerBgc}></Text>
                </>
              )}
            </View>
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
}

export default DeliveryFormView;
